import {computed, makeObservable, observable} from 'mobx';

import type {Nullable} from '../../../utils/utility-types';
import type {QuestionModel} from '../Question/Question.model';

export type AnswerModelProps<Value, Model = QuestionModel> = {
  question: Model;
  value: Nullable<Value>;
};

export abstract class AnswerModel<Value = unknown, Model = QuestionModel> {
  public question: Model;
  public value: Nullable<Value> = null;

  protected constructor(props: AnswerModelProps<Value, Model>) {
    this.question = props.question;
    this.value = props.value;

    makeObservable(this, {
      isValid: computed,
      value: observable,
    });
  }

  abstract get isValid(): boolean;

  abstract toString(): string;
}
